import { Typography } from "@mui/material";

const OpponentName = ({ value, color }) => {
  return (
    <Typography
      variant="body1"
      sx={{
        color: color,
        fontSize: "14px",
        fontWeight: "bold",
        textTransform: "uppercase",
      }}
    >
      {value}
    </Typography>
  );
};

export default OpponentName;